// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DiscountEditController = function ($scope, $rootScope, $routeParams, $location, $timeout, Discount, DiscountByPlanGroup, ProductInfo, gettextCatalog, gettext) {
    const DURATION_TYPE = Object.freeze({
        'Unlimited': 'Unlimited',
        'FirstContractPeriod': 'FirstContractPeriod',
        'FixedPeriod': 'FixedPeriod',
    });

    $scope.durationTypes = DURATION_TYPE;

    if ($routeParams.discountId) {
        $scope.discount = Discount.get({ discountId: $routeParams.discountId }, function () {
            $scope.duration = $scope.discount.Duration || { Quantity: 1, Unit: "Month" };
        });
    } else {
        $scope.discount = new DiscountByPlanGroup();
        $scope.discount.PlanGroupId = $routeParams.planGroupId;
        $scope.discount.Effect = { ReductionPercent: 0, Type: "Relative" };
        $scope.duration = { Quantity: 1, Unit: "Month" };
        $scope.discount.Targets = {};
        $scope.discount.DurationType = DURATION_TYPE.Unlimited;
    }

    $scope.productInfo = ProductInfo.get();

    $scope.popoverText = {
        description: gettext("The description that gets displayed on the invoice and on the hosted self service page")
    }

    function finish() {
        $location.path("/products");
    }

    function selectMany(list, state) {
        for (var i = 0; i < list.length; i++) {
            var product = list[i];
            $scope.discount.Targets[product.Id] = state;
        }
    }

    $scope.selectPlan = function (id, state) {
        selectMany($scope.productInfo.PlanVariantsByPlanId(id), state);
    };

    $scope.selectComponents = function (state) {
        selectMany($scope.productInfo.ComponentsByPlanGroupId($scope.discount.PlanGroupId), state);
    };

    $scope.selectPlans = function (state) {
        var planVariants = [];
        var plans = $scope.productInfo.PlansByPlanGroupId($scope.discount.PlanGroupId);
        for (var i = 0; i < plans.length; i++) {
            var plan = plans[i];
            var planVariantsByPlan = $scope.productInfo.PlanVariantsByPlanId(plan.Id);
            for (var j = 0; j < planVariantsByPlan.length; j++) {
                var planVariant = planVariantsByPlan[j];
                planVariants.push(planVariant);
            }
        }
        selectMany(planVariants, state);
    };

    $scope.cancel = finish;

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form))
            return;

        if ($scope.discount.DurationType === DURATION_TYPE.FixedPeriod) {
            $scope.discount.Duration = $scope.duration;
        } else {
            $scope.discount.Duration = null;
        }

        if ($routeParams.discountId) {
            $scope.discount.$update({ discountId: $scope.discount.Id }, finish);
        } else {
            $scope.discount.$save({ planGroupId: $routeParams.planGroupId }, finish);
        }
    };
};
DiscountEditController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$timeout', 'Discount', 'DiscountByPlanGroup', 'ProductInfo', 'gettextCatalog', 'gettext'];
